/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from "react";
import { useMedicalCareContext } from "../../../../contexts/MedicalCareContext";

export const KeyPressShortCutTabs = function () {
  const { setRegisterAreaTab } = useMedicalCareContext();

  const shortCutsTabs = {
    "Control+1": () => setRegisterAreaTab(0),
    "Control+2": () => setRegisterAreaTab(1),
    "Control+3": () => setRegisterAreaTab(2),
    "Control+4": () => setRegisterAreaTab(3),
    "Control+5": () => setRegisterAreaTab(4),
    "Control+6": () => setRegisterAreaTab(5),
    "Control+7": () => setRegisterAreaTab(6),
    "Control+8": () => setRegisterAreaTab(7),
    "Control+9": () => setRegisterAreaTab(8),
    "Control+0": () => setRegisterAreaTab(9),
  };

  // Forma funcional do setter: o listener é registrado uma única vez por
  // montagem e ainda assim lê a aba atual (sem capturar valor obsoleto).
  const moveDown = () => {
    setRegisterAreaTab((prev: number) => {
      const tabMove = prev + 1;
      return tabMove > 9 ? 0 : tabMove;
    });
    return;
  };

  const moveUp = () => {
    setRegisterAreaTab((prev: number) => {
      const tabMove = prev - 1;
      return tabMove < 0 ? 9 : tabMove;
    });

    return;
  };

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    const key = event.key;
    const isCtrl = event.ctrlKey;

    if (isCtrl && key === "ArrowDown") {
      event.preventDefault();
      moveDown();
    } else if (isCtrl && key === "ArrowUp") {
      event.preventDefault();
      moveUp();
    }

    if (isCtrl && key === "1") {
      event.preventDefault();
      shortCutsTabs["Control+1"]();
    } else if (isCtrl && key === "2") {
      event.preventDefault();
      shortCutsTabs["Control+2"]();
    } else if (isCtrl && key === "3") {
      event.preventDefault();
      shortCutsTabs["Control+3"]();
    } else if (isCtrl && key === "4") {
      event.preventDefault();
      shortCutsTabs["Control+4"]();
    } else if (isCtrl && key === "5") {
      event.preventDefault();
      shortCutsTabs["Control+5"]();
    } else if (isCtrl && key === "6") {
      event.preventDefault();
      shortCutsTabs["Control+6"]();
    } else if (isCtrl && key === "7") {
      event.preventDefault();
      shortCutsTabs["Control+7"]();
    } else if (isCtrl && key === "8") {
      event.preventDefault();
      shortCutsTabs["Control+8"]();
    } else if (isCtrl && key === "9") {
      event.preventDefault();
      shortCutsTabs["Control+9"]();
    } else if (isCtrl && key === "0") {
      event.preventDefault();
      shortCutsTabs["Control+0"]();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  return <> </>;
};

export const KeyPressShortCutAreas = function () {
  const { setActiveStep } = useMedicalCareContext();

  const shortCutsAreas = {
    "Alt+1": () => setActiveStep(0),
    "Alt+2": () => setActiveStep(1),
    "Alt+3": () => setActiveStep(2),
  };

  const moveRight = () => {
    setActiveStep((prev: number) => {
      const tabMove = prev + 1;
      return tabMove > 2 ? 0 : tabMove;
    });
    return;
  };

  const moveLeft = () => {
    setActiveStep((prev: number) => {
      const tabMove = prev - 1;
      return tabMove < 0 ? 2 : tabMove;
    });

    return;
  };

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    const key = event.key;
    const isAlt = event.altKey;
    const isCtrl = event.ctrlKey;

    if (isCtrl && key === "ArrowLeft") {
      event.preventDefault();
      moveLeft();
    } else if (isCtrl && key === "ArrowRight") {
      event.preventDefault();
      moveRight();
    }

    if (isAlt && key === "1") {
      event.preventDefault();
      shortCutsAreas["Alt+1"]();
    } else if (isAlt && key === "2") {
      event.preventDefault();
      shortCutsAreas["Alt+2"]();
    } else if (isAlt && key === "3") {
      event.preventDefault();
      shortCutsAreas["Alt+3"]();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  return <> </>;
};

export const KeyPressShortCutInterventionTabs = function () {
  const { setInterventionTab } = useMedicalCareContext();

  const moveDown = () => {
    setInterventionTab((prev: number) => {
      const tabMove = prev + 1;
      return tabMove > 3 ? 0 : tabMove;
    });
    return;
  };

  const moveUp = () => {
    setInterventionTab((prev: number) => {
      const tabMove = prev - 1;
      return tabMove < 0 ? 3 : tabMove;
    });

    return;
  };

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    const key = event.key;
    const isCtrl = event.ctrlKey;

    if (isCtrl && key === "ArrowUp") {
      event.preventDefault();
      moveUp();
    } else if (isCtrl && key === "ArrowDown") {
      event.preventDefault();
      moveDown();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  return <> </>;
};
